// Firebase configuration for WANTD
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  sendEmailVerification,
  onAuthStateChanged,
  updateProfile,
  reload,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCNA-WDb2VrQsPp3umHvC3t3sfksiAuCgw",
  authDomain: "dev.wantd.au",
  projectId: "wantd-dev-488012",
  storageBucket: "wantd-dev-488012.firebasestorage.app",
  messagingSenderId: "330855054368",
  appId: "1:330855054368:web:38a9c829546b70068e5045"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Firebase Cloud Messaging (web push)
// messaging will be null in environments where FCM is not supported (e.g. Firefox
// without SW support, or during SSR). Always null-check before using.
let messaging = null;
try {
  messaging = getMessaging(app);
} catch {
  // FCM not supported in this environment
}

// Google Auth Provider
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'  // Always show account selector
});

export {
  auth,
  messaging,
  getToken,
  onMessage,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  sendEmailVerification,
  onAuthStateChanged,
  updateProfile,
  reload,
  googleProvider,
  signInWithPopup
};
